'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ToastMessage = require('./components/ToastMessage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ToastMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/components/toast-message/index.js
// module id = 1495
// module chunks = 1